import { render, staticRenderFns } from "./ConnectionCard.vue?vue&type=template&id=ae452a52&"
import script from "./ConnectionCard.vue?vue&type=script&lang=ts&"
export * from "./ConnectionCard.vue?vue&type=script&lang=ts&"
import style0 from "./ConnectionCard.vue?vue&type=style&index=0&id=ae452a52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports